"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
var signature_check_1 = require("./signature-check");
var wx = require('./weixin-js-sdk');
var WxappSdk = /** @class */ (function () {
    function WxappSdk(config) {
        /** 环境 */
        // this.mode = config && config.mode
        /** 是否关闭内部签名，配置 */
        this.isCloseSignature = config && config.sign && config.sign.closeSign;
        /** 签名请求参数 */
        this.signRequestParams = config && config.sign && config.sign.requestParams;
        /** ios初始获取url用以签名 */
        this.iosJSSDKURL = location.href.split('#')[0];
    }
    /**
     * 支付跳转api，无需签名配置，方式一：手动传入successUrl/failUrl，
     * 方式二：uip自动填充document.url?payresult=success/fail
     * */
    WxappSdk.prototype.requestPayment = function (payParams) {
        var payParamsCheck = __assign({}, payParams);
        if (!(payParamsCheck.successUrl && payParamsCheck.failUrl)) {
            var href = config_1.checkhrefUrl(location.href, config_1.paymentPath.PAYSUCCESS);
            href = config_1.checkhrefUrl(href, config_1.paymentPath.PAYFAIL);
            var isQuery = href.indexOf('?') !== -1;
            var hrefUrl = href + (isQuery ? (href.split('?')[1] ? '&' : '') : '?');
            payParamsCheck.successUrl = hrefUrl + config_1.paymentPath.PAYSUCCESS;
            payParamsCheck.failUrl = hrefUrl + config_1.paymentPath.PAYFAIL;
        }
        var payParamsStr = config_1.serializeParams(payParamsCheck);
        var payUrl = config_1.paymentPath.WXPATH + payParamsStr;
        wx.miniProgram.navigateTo({
            url: payUrl
        });
    };
    /**
     * 路由跳转能力api
     */
    WxappSdk.prototype.routerPush = function (type, params) {
        var miniparams = params || {};
        return new Promise(function (resolve, reject) {
            if (!wx.miniProgram[type]) {
                return reject('error router');
            }
            wx.miniProgram[type](__assign(__assign({}, miniparams), { success: function (res) {
                    resolve(res);
                }, fail: function (err) {
                    reject(err);
                } }));
        });
    };
    /**
     * 直接跳转至微信小程序某页面
     */
    WxappSdk.prototype.navigate = function (url, params) {
        var fullpath = url + '?' + config_1.serializeParams(params);
        return this.routerPush(config_1.routerType.NAVIGATETO, {
            url: fullpath
        });
    };
    /**
     * 路由跳转回首页
     */
    WxappSdk.prototype.pushHome = function () {
        return this.routerPush(config_1.routerType.SWITCHTAB, { url: config_1.paymentPath.WXPUSHHOMEPATH });
    };
    /**
     * 获取当前环境
     */
    WxappSdk.prototype.getEnv = function () {
        return new Promise(function (resolve) {
            wx.miniProgram.getEnv(function (res) {
                resolve(res);
            });
        });
    };
    /**
     *
     * 向小程序发送消息，会在特定时机（小程序后退、组件销毁、分享）触发组件的message事件
     */
    WxappSdk.prototype.postMessage = function (params) {
        wx.miniProgram.postMessage(params);
    };
    // 以上接口不需要签名配置， 以下接口需要签名配置
    /**
     *
     * 签名, 由于js安全域名接口限制，不提供插件内部签名接口，只接收外部传入签名接口参数
     */
    WxappSdk.prototype.signature = function () {
        // 不需要内部签名
        if (this.isCloseSignature) {
            return Promise.resolve();
        }
        // 前端需要用js获取当前页面除去'#'hash部分的链接（可用location.href.split('#')[0]获取,
        // 而且需要encodeURIComponent）???，因为页面一旦分享，微信客户端会在你的链接末尾加入其它参数，如果不是动态获取当前链接，将导致分享后的页面签名失败。
        // 因为后台签名的关系，暂时去掉encodeURIComponent
        var JSSDKURL = location.href.split('#')[0];
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isIOS) {
            JSSDKURL = this.iosJSSDKURL;
        }
        return signature_check_1.signatureCheck(JSSDKURL, this.signRequestParams);
    };
    /**
     * 签名配置, 通过config接口注入权限验证配置, 签名配置信息由调用方提供
     */
    WxappSdk.prototype.config = function (params) {
        return wx.config(params);
    };
    /**
     * 通过ready接口处理成功验证
     */
    WxappSdk.prototype.ready = function () {
        return new Promise(function (resolve) {
            wx.ready(function () {
                resolve({});
            });
        });
    };
    /**
     * 通过error接口处理失败验证
     */
    WxappSdk.prototype.error = function () {
        return new Promise(function (resolve) {
            wx.error(function (res) {
                resolve(res);
            });
        });
    };
    /**
     * 判断当前客户端版本是否支持指定JS接口
     */
    WxappSdk.prototype.checkJsApi = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('checkJsApi', params);
    };
    /**
     *
     * 公用接口回调
     */
    WxappSdk.prototype.wxSetWay = function (wayName, params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.signature()
                .then(function () {
                wx[wayName](__assign(__assign({}, params), { success: function (res) {
                        resolve(res);
                    } }));
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    /**
     * 拍照或从手机相册中选图接口
     */
    WxappSdk.prototype.chooseImage = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('chooseImage', params);
    };
    /**
     * 预览图片接口
     */
    WxappSdk.prototype.previewImage = function (params) {
        this.signature().then(function () {
            wx.previewImage(params);
        });
    };
    /**
     * 上传图片接口
     */
    WxappSdk.prototype.uploadImage = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('uploadImage', params);
    };
    /**
     * 下载图片接口
     */
    WxappSdk.prototype.downloadImage = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('downloadImage', params);
    };
    /**
     * 使用微信内置地图查看位置接口
     */
    WxappSdk.prototype.openLocation = function (params) {
        this.signature().then(function () {
            wx.openLocation(params);
        });
    };
    /**
     * 获取地理位置
     */
    WxappSdk.prototype.getLocation = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('getLocation', params);
    };
    /**
     * 调起微信扫一扫接口
     */
    WxappSdk.prototype.scanQRCode = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('scanQRCode', params);
    };
    /**
     * 拉取适用卡券列表并获取用户选择信息
     */
    WxappSdk.prototype.chooseCard = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('chooseCard', params);
    };
    /**
     * 批量添加卡券接口
     */
    WxappSdk.prototype.addCard = function (params) {
        if (params === void 0) { params = {}; }
        return this.wxSetWay('addCard', params);
    };
    /**
     * 查看微信卡包中的卡券接口
     */
    WxappSdk.prototype.openCard = function (params) {
        this.signature().then(function () {
            wx.openCard(params);
        });
    };
    /**
     * 改微信title
     */
    WxappSdk.prototype.setNavigationBarTitle = function (params) {
        return this.wxSetWay('setNavigationBarTitle', params);
    };
    // 以下接口公众号可用
    /**
     * 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
     */
    WxappSdk.prototype.updateAppMessageShareData = function (params, closeSign) {
        if (closeSign === void 0) { closeSign = false; }
        // 是否关掉api内部签名
        if (closeSign) {
            // 直接调用原始分享api
            return wx.updateAppMessageShareData(__assign({}, params));
        }
        return this.wxSetWay('updateAppMessageShareData', params);
    };
    /**
     * 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
     */
    WxappSdk.prototype.updateTimelineShareData = function (params) {
        return this.wxSetWay('updateTimelineShareData', params);
    };
    /**
     * 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
     */
    WxappSdk.prototype.onMenuShareWeibo = function (params) {
        return this.wxSetWay('onMenuShareWeibo', params);
    };
    /**
     * 批量隐藏功能按钮接口
     */
    WxappSdk.prototype.hideMenuItems = function (params) {
        this.signature().then(function () {
            wx.hideMenuItems(params);
        });
    };
    /**
     * 获取网络类型，返回网络类型2g，3g，4g，wifi
     */
    WxappSdk.prototype.getNetworkType = function () {
        return new Promise(function (resolve, reject) {
            wx.getNetworkType({
                success: function (res) {
                    resolve(res.networkType);
                },
                fail: function () {
                    resolve('');
                }
            });
        });
    };
    /**
     * 批量显示功能按钮接口
     */
    WxappSdk.prototype.showMenuItems = function (params) {
        this.signature().then(function () {
            wx.showMenuItems(params);
        });
    };
    /**
     * 隐藏所有非基础按钮接口
     */
    WxappSdk.prototype.hideAllNonBaseMenuItem = function () {
        this.signature().then(function () {
            wx.hideAllNonBaseMenuItem();
        });
    };
    /**
     * 显示所有功能按钮接口
     */
    WxappSdk.prototype.showAllNonBaseMenuItem = function () {
        this.signature().then(function () {
            wx.showAllNonBaseMenuItem();
        });
    };
    /**
     * H5调起支付分-授权服务
     */
    WxappSdk.prototype.openBusinessView = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.signature()
                .then(function () {
                // sdk公用函数
                wx.invoke('openBusinessView', params, function (res) {
                    // 从微信侧小程序返回时会执行这个回调函数
                    if (parseInt(res.err_code) === 0) {
                        // 返回成功
                        resolve(res);
                    }
                    else {
                        // 返回失败
                        reject(res);
                    }
                });
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    return WxappSdk;
}());
exports.default = (function (config) { return function (UIP) {
    var wxapp = new WxappSdk(config);
    UIP.wxapp = wxapp;
}; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/wxapp-sdk/dist/index.js
// module id = Lyow
// module chunks = 1